import {
  skipToken,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { StatusCode, type OrderShuffle } from '@hungryroot/rest';
import { getApiV2CustomersCustomerIdOrdersOrderIdIsShuffling } from '@hungryroot/rest/api/v2/customers/[id]/orders/[order_id]/is_shuffling/get/get-api-v2-customers-customer_id-orders-order_id-is_shuffling';

interface UseGetOrderShufflingStatusProps {
  orderId?: number;
  options?: Omit<UseQueryOptions<OrderShuffle, Error>, 'queryKey' | 'queryFn'>;
}

export function useGetOrderShufflingStatus(
  props: UseGetOrderShufflingStatusProps
) {
  const { orderId, options } = props;

  return useQuery({
    queryKey: ['Orders', 'Shuffling Status', orderId],
    queryFn: Number.isFinite(orderId)
      ? async () => {
          const resp =
            await getApiV2CustomersCustomerIdOrdersOrderIdIsShuffling({
              orderId: orderId as number,
            });

          if (resp.status !== StatusCode.SuccessOK) {
            throw new Error(JSON.stringify(resp.data, null, 2));
          }

          return resp.data;
        }
      : skipToken,
    ...options,
  });
}
